import React, { useState } from "react";
import { compose } from "recompose";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Page, withTable } from "components/common";
import { withXeroErrors } from "components";
import { Table } from "reactstrap";
import { formatPercentage } from "services/util";
import BackButton from "components/refactoring/BackButton";
import LoadingMsg from "components/common/LoadingMsg";

export const TaxRatesList = ({
  data,
  TableContainer,
  match,
  XeroTableDataFetch,
  XeroErrors,
}) => {

  const {t} = useTranslation()
  const [search, setSearch] = useState('');

  const handleInputChange = (event) => {
    setSearch(event.target.value);
  };

  const filteredResults = data?.results?.filter((item) => {
    const TaxName = search ? item?.Name?.toLowerCase().includes(search?.toLowerCase()) : true;
    const TaxCode = search ? item?.TaxType?.toLowerCase().includes(search?.toLowerCase()) : true;
  
    return (TaxName || TaxCode);
  });
  
  return (

  <Page title="Tax Rates" className="inv-table">
    <div className="flex flex-column mb-2">
      <BackButton />
    </div>
    <div className="d-flex justify-content-between align-items-center mb-4">
      <input
        className="form-control"
        placeholder={t("Search by Tax Name or Tax Number")}
        type="text"
        id="searchInput"
        value={search}
        onChange={handleInputChange}
      />
      <Link to={`${match.url}/new`} className="btn btn-primary">
        <span className="fa fa-plus mr-2" />
        <Trans>Add Tax Rate</Trans>
      </Link>
    </div>
    <XeroErrors />
    {!data.loading ?
    <TableContainer idKey="Name">
      <Table size="sm">
        <thead>
          <tr>
            <th className="text-left" sortBy="Name">
              <Trans>Name</Trans>
            </th>
            <th className="text-left">
              <Trans>Tax Number</Trans>
            </th>
            <th sortBy="EffectiveRate" className="text-left" >
              <Trans>Tax Rate</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredResults.map((i) => (
            <tr key={i.Name}>
              <td className="text-left">
                <Link to={`${match.url}/${i.TaxType}`}>{i.Name}</Link>
              </td>
              <td className="text-left">
                {i.TaxType}
              </td>
              <td className="text-left">
                {formatPercentage(i.DisplayTaxRate / 100)}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>:<LoadingMsg/>}
    {!data.loading && filteredResults.length === 0 && <p className="text-center"><Trans>No results found</Trans></p>}
    <XeroTableDataFetch />
  </Page>
)};

export const enhance = compose(
  withXeroErrors(),
  withTable({
    url: "taxrates",
    idKey: "Name",
    ordering: "Name",
  })
);

export default enhance(TaxRatesList);
